const INITIAL_STATE = {
  timeTrackingReasonsList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_TIME_TRACKING_REASONS_LIST':
      return { ...state, timeTrackingReasonsList: action.timeTrackingReasons };
    default:
      return state;
  }
};
